import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    // bind once, loop through every linkTarget
    this.track = this.track.bind(this);
    this.linkTargets.forEach(el =>
      el.addEventListener("pointerdown", this.track, { passive: true })
    );
  }

  disconnect() {
    this.linkTargets.forEach(el =>
      el.removeEventListener("pointerdown", this.track)
    );
  }

  track() {
    // — Facebook Pixel (unchanged) —
    if (window.fbq) {
      fbq("trackCustom", "WhatsappClick");
    }

    // // — Google Ads (new beacon transport, no preventDefault/window.open) —
    // if (window.gtag) {
    //   gtag("event", "conversion", {
    //     send_to: "AW-11137878346",
    //     transport_type: "beacon"
    //   });
    // }

    // — Bing UET (unchanged) —
    if (typeof uet_report_conversion === "function") {
      uet_report_conversion();
    }
  }
}
